import moment from "moment-timezone";

export function formatVolunteerShiftDay(date: Date): string {
  return moment(date).tz("America/New_York").format("ddd, MMM D");
}

export function formatVolunteerShiftDate(date: Date): string {
  return moment(date).tz("America/New_York").format("ddd MMM D");
}

export function getVolunteerShiftDayOfWeek(date: Date): string {
  return moment(date).tz("America/New_York").format("dddd");
}

export function formatTime(date: Date) {
  return moment(date).tz("America/New_York").format("h:mm A");
}

export function formatDayOfWeek(date: Date) {
  return moment(date).tz("America/New_York").format("ddd").toUpperCase();
}

export function formatDateOrdinal(date: Date) {
  return moment(date).format("dddd, MMMM Do");
}

export function getVolunteerShiftHourAndMinute(date: Date): string {
  const formattedDate = moment(date).tz("America/New_York");
  const minutes = formattedDate.format("mm");
  const hourFormat = minutes === "00" ? "h A" : "h:mm A";
  return formattedDate.format(hourFormat);
}

export function getVolunteerShiftHourAndMinute24Hour(date: Date): string {
  const formattedDate = moment(date).tz("America/New_York");
  return formattedDate.format("HH:mm");
}
